import './App.css';
import React from 'react';
/* Added browser Router */
import { BrowserRouter as Router,
          Routes,
          Route} from 'react-router-dom'

import Admin from './components/Admin'
import LandingPage from './components/User/LandingPage'
import Faqs from './components/User/Faqs'
import ContactUs from './components/User/ContactUs'
import Services from './components/User/Services'
import Jobs from './components/User/Jobs'

import ParticularJobResume from './components/User/ParticularJobResume';
import SubmitResume from './components/User/SubmitResume';
import FillVacancy from './components/User/FillVacancy'


function App() {

  return (
    <Router>


       <Routes>
         <Route path="/" element={<LandingPage />} />
         <Route path="/Faqs" element={<Faqs />} />
         <Route path="/ContactUs" element={<ContactUs />} />
         <Route path="/Services" element={<Services />} />
         <Route path="/Jobs" element={<Jobs />} />

         <Route path="/apply/:jobId" element={<ParticularJobResume />} />
         <Route path="/SubmitResume" element={<SubmitResume />} />
         <Route path="/FillVacancy" element={<FillVacancy />} />

         <Route path="/admin/*" element={<Admin/>} />
       </Routes>
    </Router>
  );
}

export default App;
